module.exports = __webpack_public_path__ + "img/mizoram.0eb4e1dd.svg";